import { useTranslation } from "react-i18next";
import Modal, { ModalProps } from "../Modal/Modal";
import Textfield from "@/Components/Input/Textfield";
import Button from "@/Components/Button/Button";
import { useAtom } from "jotai";
import { discountCodeAtom } from "@/shared/atoms";
import useDidUpdateEffect from "@/shared/hooks/useDidUpdateEffect";
import { useIsCartEmpty } from "@/shared/hooks/useCartHook";
import ModalTitle from "../Modal/ModalTitle";
import ModalAction from "../Modal/ModalAction";
import { useRef } from "react";
import useFocusAndCursorToEnd from "@/shared/hooks/useFocusAndCursorToEndHook";
import { useForm } from "react-hook-form";
import Tooltip from "../Tooltip/Tooltip";

const PosOrderDiscountCodeModal = ({ onExit, ...props }: ModalProps) => {
  const { t } = useTranslation();
  const ref = useRef<HTMLInputElement>(null);
  const [discountCode, setDiscountCode] = useAtom(discountCodeAtom);
  const isCartEmpty = useIsCartEmpty();
  const { register, handleSubmit } = useForm();
  useFocusAndCursorToEnd(ref);

  useDidUpdateEffect(() => {
    if (discountCode.isApplied === false || discountCode.code.length === 0) {
      onExit();
    }
  }, [discountCode.isApplied, discountCode.code]);

  const onSubmit = (data) => {
    setDiscountCode({
      isApplied: data.code?.length > 0,
      code: data.code,
    });
  };

  return (
    <Modal width="40rem" onExit={onExit} {...props}>
      <ModalTitle>{t("posOrders.enterDiscountCode")}</ModalTitle>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="flex flex-col gap-8"
      >
        <Textfield
          name="code"
          ref={(e) => {
            register(e, {});
            ref.current = e;
          }}
          placeholder={t("posOrders.enterDiscountCode")}
          defaultValue={discountCode.code}
        />
        <ModalAction>
          {isCartEmpty ? (
            <Tooltip content={t("posOrders.addProduct")}>
              <div>
                <Button
                  type="submit"
                  style={{ marginTop: "1rem" }}
                  isPending={discountCode.isApplied}
                  isDisabled={isCartEmpty}
                >
                  {t("posOrders.save")}
                </Button>
              </div>
            </Tooltip>
          ) : (
            <Button
              type="submit"
              style={{ marginTop: "1rem" }}
              isPending={discountCode.isApplied}
              isDisabled={isCartEmpty}
            >
              {t("posOrders.save")}
            </Button>
          )}
        </ModalAction>
      </form>
    </Modal>
  );
};

export default PosOrderDiscountCodeModal;
